import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../api/ApiContext.jsx";
import { useApi } from "../hooks/useApi.js";
import { NotificationPreferences } from "../components/index.js";
import { AsyncBoundary, InlineMessage, errorText } from "../ui/Feedback.jsx";

export default function NotificationsScreen() {
  const api = useApiClient();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const query = useApi(() => api.me.notifications(), [api]);

  async function handleSave(rows) {
    setMessage(null);
    try {
      await api.me.saveNotifications(rows);
      setMessage({ tone: "success", text: "Notification preferences saved." });
    } catch (err) {
      setMessage({
        tone: err?.isNotConfigured ? "warning" : "danger",
        text: errorText(err, "Could not save your preferences."),
      });
    }
  }

  return (
    <div>
      {message ? <InlineMessage tone={message.tone}>{message.text}</InlineMessage> : null}
      <AsyncBoundary query={query} onBack={() => navigate("/")}>
        {(data) => (
          <NotificationPreferences
            // An empty list keeps the component's built-in 5-row default.
            rows={data.rows.length ? data.rows : undefined}
            onSave={handleSave}
          />
        )}
      </AsyncBoundary>
    </div>
  );
}
